import { BaseController } from 'controllers/BaseController'
import { GetProjectEstimationTemplateResponse } from 'services/APIs/InternalAPI/internal-api.contracts'
import { GetPartyId } from 'store/storeUtils'
import { ProjectDeliveryEstimationSettingsAPI } from './ProjectDeliveryEstimationSettings.api'

export interface IProjectDeliveryEstimationSettingsAPI {
  GetProjectDeliveryEstimationFileData: () => Promise<GetProjectEstimationTemplateResponse>
  UploadProjectDeliveryEstimationFile: (file: File) => Promise<void>
  DeleteProjectDeliveryEstimationFile: () => Promise<void>
  DownloadProjectDeliveryEstimationFile: () => Promise<boolean>
}

export class ProjectDeliveryEstimationSettingsController extends BaseController<IProjectDeliveryEstimationSettingsAPI> {
  constructor() {
    super((onRequestChanged) => {
      const partyId = GetPartyId()
      return new ProjectDeliveryEstimationSettingsAPI(partyId, onRequestChanged)
    })
  }

  public GetProjectDeliveryEstimationFileData() {
    try {
      return this.api.GetProjectDeliveryEstimationFileData()
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public UploadProjectDeliveryEstimationFile(file: File) {
    try {
      return this.api.UploadProjectDeliveryEstimationFile(file)
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public DeleteProjectDeliveryEstimationFile() {
    try {
      return this.api.DeleteProjectDeliveryEstimationFile()
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public DownloadProjectDeliveryEstimationFile() {
    try {
      return this.api.DownloadProjectDeliveryEstimationFile()
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
